import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { api, formatApiErrorDetail } from "../api";

export default function ResetPassword() {
  const nav = useNavigate();
  const params = new URLSearchParams(window.location.search);
  const [token] = useState(params.get("token") || "");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [ok, setOk] = useState(false);
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError(""); setLoading(true);
    try {
      await api.post("/auth/reset-password", { token, password });
      setOk(true);
      setTimeout(() => nav("/login", { replace: true }), 1800);
    } catch (err) {
      setError(formatApiErrorDetail(err.response?.data?.detail) || err.message);
    } finally { setLoading(false); }
  };

  return (
    <div className="auth-wrap">
      <aside className="auth-side">
        <div>
          <div className="brand-box"><img src="/rotasaude-logo.png" alt="RotaSaúde" /></div>
          <h1>Nova senha</h1>
          <p>Defina uma nova senha para continuar acessando sua operação com segurança.</p>
        </div>
        <div className="foot">RotaSaúde SaaS</div>
      </aside>
      <div className="auth-panel">
        <form className="auth-card" onSubmit={submit}>
          <div className="mobile-logo"><img src="/rotasaude-logo.png" alt="RotaSaúde" /></div>
          <h2>Redefinir senha</h2>
          <p className="sub">Escolha uma nova senha.</p>
          {error && <div className="auth-error">{error}</div>}
          {ok && <div className="auth-ok" data-testid="reset-ok">Senha redefinida! Redirecionando…</div>}
          {!token && <div className="auth-error">Token ausente. Use o link enviado ao seu e-mail.</div>}
          <label className="auth-field">Nova senha
            <input data-testid="reset-password" type="password" value={password} onChange={(e) => setPassword(e.target.value)} required minLength={6} />
          </label>
          <button className="auth-btn" disabled={loading || !token} data-testid="reset-submit">{loading ? "Salvando…" : "Redefinir senha"}</button>
          <div className="auth-toggle"><a href="/login">Voltar ao login</a></div>
        </form>
      </div>
    </div>
  );
}
